/** Data every page needs: the connection and the plan's entitlements. Store-sync data loads only on Home and Settings. */
import type { useAppBridge } from '@shopify/app-bridge-react'
import { useShopifyConnection } from './useShopifyConnection'
import { useShopifyEntitlements } from './useShopifyEntitlements'

export function useShopifyPageData({
  shopify,
  expectedShop,
}: {
  shopify: ReturnType<typeof useAppBridge>
  expectedShop: string | null
}) {
  const {
    scope: verifiedScope,
    verifiedShop,
    readiness,
    isLoading,
    isDisconnectUnconfirmed,
  } = useShopifyConnection(shopify, expectedShop)
  const isTestFeedConnected = !!verifiedScope
  const entitlementsQuery = useShopifyEntitlements(shopify, {
    isTestFeedConnected,
    connectionId: verifiedScope?.connectionId ?? null,
    shopDomain: verifiedShop,
    orgId: verifiedScope?.orgId ?? null,
  })
  return {
    verifiedScope,
    verifiedShop,
    readiness,
    isLoading,
    isDisconnectUnconfirmed,
    entitlements: entitlementsQuery.data,
  }
}
